export default {
    api: {
        url: 'https://hrmapi.mobcoder.com/hrm/api/v1/',
        mode: 'cors'
    }
}
